import { apiClientV2 } from '@/services/rest-api/apiClient'
let baseURL = process.env.VUE_APP_REST_API_VSMS
baseURL = baseURL[baseURL.length] === '/' ? baseURL.slice(0, -1) : baseURL

export const get = async (queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParam?.filters || undefined,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/vehicle',
    params: params,
  })

  return response?.data
}

export const show = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/vehicle`,
    params: {
      filters: `id eq ${id}`,
    },
  })

  return response?.data
}

export const getVehicleCategory= async (params = {}) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/vehicle/category',
    params: {
      limit: params?.limit,
      page: params?.page,
      sorts: params?.sorts?.length > 0 ? params.sorts : undefined,
      search: params?.search || undefined,
      filters: params?.filters || undefined,
    },
  })

  return response?.data
}

export const getVehicleType= async (params = {}) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/vehicle/type',
    params: {
      limit: params?.limit,
      page: params?.page,
      sorts: params?.sorts?.length > 0 ? params.sorts : undefined,
      search: params?.search || undefined,
      filters: params?.filters || undefined,
    },
  })

  return response?.data
}

